// extracted by mini-css-extract-plugin
export var container = "CourseSidebarVideo-module--container--sgNAZ";
export var name = "CourseSidebarVideo-module--name--HuEzp";
export var time = "CourseSidebarVideo-module--time--tPwWz";
export var video = "CourseSidebarVideo-module--video--Kgatt";
export var video_info = "CourseSidebarVideo-module--video_info--JkEaw";
export var video_preview = "CourseSidebarVideo-module--video_preview--l38xf";
export var watched = "CourseSidebarVideo-module--watched--kis1G";